import { defineStore } from 'pinia'
import { ref } from 'vue'

// Chunk loading state use for progress indicator and
// scroll position restoration (postpones scroll restoration until
// chunk is loaded)
export const useScrollPositionResolverStore = defineStore(
    'app.lazyLoader',
    () => {
        const isLazyLoadInProgress = ref<boolean>(false)
        const resolveScrollPosition = ref<(() => void) | null>(null)

        return {
            isLazyLoadInProgress,
            resolveScrollPosition,
        }
    }
)
